/**
 * BarcodeHeader Component - Header for barcode management page
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Barcode as BarcodeIcon } from 'lucide-react';

interface BarcodeHeaderProps {
  isAdmin: boolean;
}

export const BarcodeHeader: React.FC<BarcodeHeaderProps> = ({ isAdmin }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/')}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <ArrowLeft className="w-5 h-5 text-gray-600" />
            </button>
            <div>
              <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
                <BarcodeIcon className="w-7 h-7 text-amber-600" />
                Gerenciador de Códigos de Barras
              </h1>
              <p className="text-sm text-gray-600 mt-1">
                {isAdmin
                  ? '🔓 Admin: Visualize TODOS os códigos de barras cadastrados e em estoque'
                  : '👀 Visualize códigos de barras dos seus jobs de contagem'}
              </p>
            </div>
          </div>
          {isAdmin && (
            <div className="bg-blue-50 border border-blue-200 px-4 py-2 rounded-lg">
              <span className="text-sm font-semibold text-blue-700">
                🔑 Modo Administrador
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
